import { Link } from 'react-router-dom';
import programCopy from '@/data/channel_program_copy.json';

export default function ChannelProgrammeModule() {
  var programmeBlocks = [];
  for (var index = 0; index < 18; index += 1) {
    var section = programCopy.sections[index];
    programmeBlocks.push(<article id={section.anchor} key={section.number} data-testid={'channel-programme-' + section.number}>
      <h3 className="text-xl font-bold text-gray-900 mb-3">{section.number}. {section.label}</h3>
      <p className="text-gray-700 leading-relaxed">{section.paragraph}</p>
    </article>);
  }
  return (
    <section className="my-16" data-testid="channel-programme-module">
      <h2 className="text-3xl font-bold text-gray-900 mb-5">{programCopy.metadata.h1}</h2>
      <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed mb-8"><p>{programCopy.intro}</p></div>
      <figure className="my-10">
        <img src="/images/channel-loyalty-18-programme-types.png" width="1254" height="1254" alt={programCopy.image.alt} className="w-full h-auto object-contain" data-testid="channel-programme-reference-image" />
        <figcaption className="mt-3 text-sm text-gray-500 text-center">{programCopy.image.caption}</figcaption>
      </figure>
      <div className="space-y-10">{programmeBlocks}</div>
      <div className="mt-12 rounded-xl bg-gray-900 p-8 text-white">
        <h3 className="text-xl font-bold mb-2">{programCopy.cta.label}</h3>
        <p className="text-gray-300 mb-5">{programCopy.cta.supporting_copy}</p>
        <Link to="/contact" className="btn btn-primary" data-testid="channel-programme-contact-cta">{programCopy.cta.label}</Link>
      </div>
    </section>
  );
}